

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface NurseIntakeOutputParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface NurseIntakeOutput {

    id?: any;
    regId: any;
    admissionId: any;
    notes: string;
    method: string;
    type:string;
    dateTime: any;
    amount: any;
    unit:any;
    site:string;
    nurseId:any;
    shiftId:any;
    createdBy:string;
    createdDate:any;
    tenantId: any;
    branchId: any;
    intakeTime?:string;
    parameters?: NurseIntakeOutputParameter[];
    links?: any;
}

export abstract class NurseIntakeOutputData {
    //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
    abstract list(url: string): Observable<NurseIntakeOutput[]>;
    abstract create(url: string, data: NurseIntakeOutput): Observable<NurseIntakeOutput[]>;
    abstract update(url: string, data: NurseIntakeOutput): Observable<NurseIntakeOutput>;
    abstract delete(url: string): Observable<any>;

}
